const $ = jQuery.noConflict()

$.fn.extend({
  instantvaluation: function () {
    self.init(this.selector)
  }
})

var self = (module.exports = {
  init: function (trigger) {
    var data = {
      action: 'valpal',
      nonce: '',
      postcode: '',
      phone: '',
      bedrooms: '1',
      email: '',
      address: '',
      street: ''
    }

    $(trigger).on('click', '#instant-valuation-next .form-staged__next',
      function (e) {
        var responseDiv = $(trigger).attr('data-response-div')

        let data = {
          // action: 'valpal',
          // nonce: document.getElementById('instant-valuation_nonce_field').value,
          // address: document.getElementById('instant-valuation-address').value,
          // buildname: document.getElementById('instant-valuation-build_name').value,
          // subBname: document.getElementById('instant-valuation-sub_build_name').value,
          // number: document.getElementById('instant-valuation-street_number').value,
          // street: document.getElementById('instant-valuation-street_name').value,
          // postcode: document.getElementById('instant-valuation-postal_code').value,
          // forename: document.getElementById('instant-valuation-forename').value,
          // surname: document.getElementById('instant-valuation-surname').value,
          // phone: document.getElementById('instant-valuation-telephone').value,
          // emailaddress: document.getElementById('instant-valuation-email').value,
          // propertytype: document.getElementById('instant-valuation-property-type').value,
          // bedrooms: document.getElementById('instant-valuation-bedrooms-min').value
        }

        $('#' + responseDiv).hide()
        $('.estimate--range .range--value').html('Estimating...')
        $('.estimate--range .predicted--value').html('Estimating...')

        $.ajax({
          type: 'POST',
          // eslint-disable-next-line no-undef
          url: myAjax.ajaxurl,
          data: data,
          success: function (response) {
            if (response.success) {
              var data = JSON.parse(response.data.data)
              var apiSuccess = data[0]
              var apiErrors = data[1]
              var apiResults = data[2]

              if (apiSuccess.status !== 'success') {
                $('#' + responseDiv)
                  .html(
                    '<div class="valpal-response">' +
                    apiErrors.errors.message +
                    '</div>'
                  )
                  .show()
              }

              $('.estimate--range .range--value')
                .html(
                  apiResults.results.minvaluation +
                    '-' +
                    apiResults.results.maxvaluation
                )
                .show()

              $('#instant-valuation-sale-value')
                .val(
                  apiResults.results.minvaluation +
                  '-' +
                  apiResults.results.maxvaluation
                )

              $('.estimate--range .predicted--value')
                .html('Predicted value = ' + apiResults.results.valuation)
                .show()

              $('#instant-valuation-rental-value').val(apiResults.results.rentalvaluation);

            } else {
              // console.log('error case', response)
            }
          }
        })
        // return false;
      }
    )

    $(document).on('click', '.pac-container.pac-logo .pac-item', function () {
      //$('#filledInstantValuationAdd').css('display', 'block');
      $('.property_val').find('.form-staged__next').trigger('click');
    })
  }
})
